/* src/app/shared/contract/contract-item/contract-thema-nego/thema-pack-managing-dialog/thema-pack-managing-dialog.component.scss */
.container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 1000px;
  height: 740px;
  margin: 0;
  overflow-y: auto;
}
.title-container {
  justify-content: flex-start;
  font: 700 16px FranceTV Brown;
}
.light-blue-horizontal-separator {
  height: 1px;
  background-color: #DFEBF7;
}
.red-title-container {
  display: flex;
  flex-direction: row;
  gap: 10px;
  color: #F03C64;
}
.red-info-container {
  display: flex;
  flex-direction: row;
  gap: 2px;
}
.red-info-container .mat-icon {
  align-self: center;
  width: 15px;
  height: 15px;
  font-size: 14px;
  color: #F03C64;
}
.red-title {
  font: 400 14px FranceTV Brown;
  color: #F03C64;
}
.bloc-container-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  background-color: #FFF;
  border-radius: 5px;
}
.bloc-container-row .bloc-container-pack {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  height: 100%;
  padding: 20px;
  background-color: rgba(36, 70, 102, 0.05);
  border-radius: 5px;
}
.bloc-container-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  height: 100%;
}
.bloc-container-row-60-p {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  height: 60%;
}
.bloc-container-row-60-p .bloc-container-channel {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 60%;
  height: 100%;
  padding: 20px;
  border-radius: 5px;
  background-color: rgba(36, 70, 102, 0.05);
  border-radius: 5px;
}
.bloc-container-row-60-p .bloc-container-share {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  height: 100%;
  padding: 20px;
  border-radius: 5px;
  background-color: rgba(36, 70, 102, 0.05);
}
.button-section {
  justify-content: flex-end;
  display: inline-flex;
}
.tv-ns-secondary-large-button-on-light-bg {
  width: 150px;
  margin-right: 25px;
}
.tv-ns-validation-large-button {
  width: 150px;
}
.container-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  align-items: center;
  padding: 10px 0;
}
.block-chip {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  border-radius: 6px;
  background-color: #6B90B3;
  font: 300 14px FranceTV Brown;
  color: #FFF;
}
.block-chip .mat-icon {
  width: 16px;
  height: 16px;
  cursor: pointer;
}
.block-chip .material-icons {
  font-size: 16px;
}
.inputs-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}
.loader-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}
.content-position {
  align-items: center;
  width: 100%;
}
.channel-logo {
  height: 16px;
}
.channel-name {
  font: 400 14px FranceTV Brown;
  color: #6B90B3;
}
.placeholder-prefix-icon {
  margin-right: 5px;
  padding-top: 2px;
  color: #0083FF;
}
.custom-channel-row-adjustment {
  padding: 5px 10px;
  margin-right: 10px;
  margin-left: 10px;
}
.lateral-padding-l {
  padding-left: 20px;
  padding-right: 20px;
}
.mat-dialog-container {
  border-radius: 25px;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type=number] {
  -moz-appearance: textfield;
}
/*# sourceMappingURL=thema-pack-managing-dialog.component.css.map */
